import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
import { verificationUser } from '@/api/login';
import { setToken, setRfleshToken } from '@/utils/auth';
export default {
  data: function data() {
    return {
      loading: true,
      sourceUrl: '' // 来源url

    };
  },
  mounted: function mounted() {
    this.hasToken();
  },
  methods: {
    hasToken: function hasToken() {
      var _this = this;

      this.sourceUrl = document.referrer;
      var urlParamObj = this.$route.query;

      if (urlParamObj.token) {
        localStorage.setItem('sourceUrl', this.sourceUrl);
        setToken(urlParamObj.token);
        this.$store.commit('SET_TOKEN', urlParamObj.token); // 新框架改动点 token->access-token

        this.$store.commit('SET_REFLESHTOKEN', urlParamObj.token); // 新框架改动点 token->access-token

        setRfleshToken(urlParamObj.token);
        this.$router.push('/');
      } else {
        this.$message.error('登录验证失败!');
        setTimeout(function () {
          window.location.replace(_this.sourceUrl);
        }, 1000);
      }
    }
  }
};